import React, { Component } from 'react';
import { connect } from 'react-redux';
import { do_action } from '../../actions';
import Contractor from './Contractor';
import Pm from './Pm';
import Designer from './Designer';
import {BASE_URL_ADMIN} from '../../data/config'
import {setVendor} from '../../actions/vendor'

class VendorDetail extends Component {
    constructor() {
        super();
        this.state = {
            form: {},
            changeVendor: false,
            changeDetail: false
        }
    }

    componentWillReceiveProps = (nextProps) => {
        this.setState({ form: nextProps.vendor })
    }

    componentWillMount = () => {
        this.setState({ form: this.props.vendor })
    }

    updateForm = (property, value) => {
        let { form } = this.state
        form[property] = value
        this.setState({ form, changeDetail: true })
    }

    changeVendor = (property, e) => {
        let { form } = this.state
        form[property] = e.target.value
        this.setState({ form, changeVendor: true })
    }

    confirmUpdate = () => {
        let confirm = true
        let {dispatch, vendor} = this.props
        if (!this.state.changeDetail && !this.state.changeVendor) return alert('Update successfully')
        if (this.props.vendor.type === 'contractor')
            do_action('update_contractor_detail', this.state.form)
                .then(data => {
                    if (data.signal) {
                        alert('Update successfully')
                        this.setState({
                            changeDetail: false,
                            changeVendor: false
                        })

                        let [dataVendor, dataDetail] = data.data
                        dataVendor = Object.assign(vendor, dataVendor)
                        if (dataDetail.company_name) {
                            dataVendor.detail = {name: dataDetail.company_name}
                        }

                        dispatch(setVendor(dataVendor))
                    }
                    else
                        alert(data.message || 'Something went wrong')
                })
                .catch(err => console.log(err))
        else if (this.props.vendor.type === 'pm')
            do_action('update_pm_detail', this.state.form)
                .then(data => {
                    if (data.signal) {
                        alert('Update successfully')
                        this.setState({
                            changeDetail: false,
                            changeVendor: false
                        })
                    }
                    else
                        alert(data.message || 'Something went wrong')
                })
        else {
            do_action('update_designer_detail', this.state.form)
                .then(data => {
                    if (data.signal) {
                        alert('Update successfully')
                        this.setState({
                            changeDetail: false,
                            changeVendor: false
                        })
                    }
                    else
                        alert(data.message || 'Something went wrong')
                })
        }
    }

    selectFile = (event) => {
        const files = event.target.files
        let params = new FormData()
        params.append('image', files[0])
        do_action('upload_image', params)
            .then(resp => {
                let url = resp.data.fileUrl;
                url = url.replace('/uploads/', '')
                this.updateForm('image', url)
            })
            .catch(err => console.log(err))
        
    }

    render() {
        let {form} = this.state
        let image = form.image ? BASE_URL_ADMIN + '/uploads/' + form.image : ''

        return (
            <div className="col-sm-9 col-sm-offset-3 col-md-10 col-md-offset-2 maindb">
                <div className="form-group clearfix">
                    <div className="pull-left">
                        <h3 className="marginT0 fontMedium">Vendor detail</h3>
                    </div>
                </div>
                <div className="form-group">
                    <div className="row">
                        <div className="col-xs-12 col-sm-12 col-md-7 col-lg-8">
                            <div className="block-room">
                                <div className="clearfix panen-heading">
                                    <div className="pull-left">
                                        <div className="big-title">Vendor Information</div>
                                    </div>
                                </div>
                                <div className="panen-body">
                                    <p className="tit fontMedium">Email</p>
                                    <div className="form-group">
                                        <input type="text" value={form.email || ''} onChange={this.changeVendor.bind(this, 'email')} className="form-control form-control-mix" readOnly={true}/>
                                    </div>
                                    <p className="tit fontMedium">Phone</p>
                                    <div className="form-group">
                                        <input type="text" value={form.phone ? form.phone : ''} onChange={this.changeVendor.bind(this, 'phone')} className="form-control form-control-mix" />
                                    </div>
                                    <p className="tit fontMedium">Password</p>
                                    <div className="form-group">
                                        <input type="password" value={form.password ? form.password : ''} onChange={this.changeVendor.bind(this, 'password')} className="form-control form-control-mix" />
                                    </div>
                                    
                                    {
                                        (this.props.vendor.type === 'contractor') ? <Contractor updateForm={this.updateForm.bind(this)} form={form} /> : (this.props.vendor.type === 'pm') ? <Pm updateForm={this.updateForm.bind(this)} form={this.state.form} /> : <Designer updateForm={this.updateForm.bind(this)} form={this.state.form} />
                                    }
                                </div>
                            </div>
                        </div>
                        <div className="col-xs-12 col-sm-12 col-md-5 col-lg-4">
                            <div className="side-a bg-white">
                                <div className="title">Action</div>
                                <div className="form-group">
                                    <a href="#" className="bg-blue btn-blue btn-block continue" onClick={this.confirmUpdate.bind(this)}>Update</a>
                                </div>
                            </div>
                            <div className="side-a bg-white">
                                <div className="form-group">
                                    <div className="title">Feature Image</div>
                                </div>
                                <div className="form-group">
                                    <div className="feature-img">
                                        {image && <img src={image} alt="" className="img" style={{height: '100%'}} />}
                                        
                                        <div className="update-img">
                                            <input type="file" accept="image/*" onChange={this.selectFile.bind(this)} name="file" id="file" className="inputfile" />
                                            <label htmlFor="file">Update Image</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStateToProps(state) {
    const { vendor } = state;
    return {
        vendor
    }
}

export default connect(mapStateToProps)(VendorDetail);